<template>
  <div class="fa">
    <div style="height: 50px; width: 100%;display: flex;justify-content: space-between;align-items: center;">
      <!-- <b style="font-weight: 700;font-size: 20px;"></b> -->
      <div>
        <el-radio-group size="small" v-model="basicInformation.searchType" @change="radioChange">
          <el-radio-button v-for="(item, index) in basicInformation.radioColumn" :key="index" :disabled="item.disabled"
            :label="item.value">{{ item.label }}</el-radio-button>
        </el-radio-group>
        <el-input style="margin-left: 20px; width: 500px;" size="small" type="text"
          v-model="basicInformation.searchMchName" @change="searchMerchant(basicInformation.searchMchName)"
          placeholder="请输入店铺名称模糊查询"></el-input>
      </div>

      <el-button type="primary" plain size="small" style="width: 150px"
        @click="getWxApplyment(basicInformation.searchType)">重 新 获 取</el-button>
    </div>
    <!-- 列表 -->
    <div>
      <el-table :lazy="true" :expand-row-keys="basicInformation.expandRowKeys" row-key="keyId"
        @expand-change="expandChange" v-loading="basicInformation.loading" ref="wtyTableRef" border :fit="true"
        :data="tableList" size="mini" type="index" height="540px" class="show-table table"
        style="height: 100%; width:100% !important" highlight-current-row :cell-style="{ padding: '5px' }"
        :header-cell-style="{
          height: '20px',
          background: '#409eff',
          color: '#fff',
        }">
        <!-- 详情 -->
        <el-table-column type="expand" label="详情">
          <template slot-scope="props">
            <!-- 微信进件状态 -->
            <div class="el-table-column-expand"
              v-if="basicInformation.searchType === 'wx' && props.row.applyInfo && props.row.applyInfo.applyment_state">
              <div style="margin: 5px 0;" class="primarya-text">申请单状态</div>
              <div style="">
                <div class="reda-text">{{ basicInformation.wxpayStatusMap[props.row.applyInfo.applyment_state].status
                }}：</div>
                <span class="">
                  <p style="font-size: 10px !important;display: inline-block;padding-right:3px;">⚫</p>{{
                    basicInformation.wxpayStatusMap[props.row.applyInfo.applyment_state].detail }}
                </span>
              </div>
              <div v-if="props.row.applyInfo.applyment_state === 'APPLYMENT_STATE_REJECTED'">
                <div class="reda-text">驳回原因：</div>
                <div v-for="(item, index) in props.row.applyInfo.audit_detail" :key="index">
                  <p style="font-size: 10px !important;display: inline-block;">⚫</p> {{
                    item.reject_reason }}
                </div>
              </div>
              <div class="reda-text">扫码查看详情</div>
              <el-image :src="props.row.applyInfo.sign_url" style="width: 100px; height: 100px"></el-image>
            </div>
            <!-- 随行付进件状态 -->
            <div class="el-table-column-expand" v-if="basicInformation.searchType === 'swift'">
              <div style="margin: 5px 0;" class="primarya-text">申请单状态</div>
              <div style="">
                <div class="reda-text">{{ props.row.applyInfo && props.row.applyInfo.taskStatus
                  ? basicInformation.swiftStatusMap[props.row.applyInfo.taskStatus].status : "未获取到" }}
                </div>
                <span class="">
                  <p style="font-size: 10px !important;display: inline-block;padding-right:3px;">⚫</p>
                  {{
                    props.row.applyInfo && props.row.applyInfo.taskStatus
                      ? basicInformation.swiftStatusMap[props.row.applyInfo.taskStatus].detail : "未获取到"
                  }}
                </span>
              </div>
              <div style="margin: 5px 0;" class="primarya-text">微信申请单状态</div>
              <div v-if="props.row.wxInfo">
                <div style="">
                  <div class="reda-text">{{ props.row.wxInfo && props.row.wxInfo.idenStatus
                    ? basicInformation.swiftWxStatusMap[props.row.wxInfo.idenStatus].status
                    : "" }}：</div>
                  <span class="">
                    <p style="font-size: 10px !important;display: inline-block;padding-right:3px;">⚫</p>{{
                      props.row.wxInfo && props.row.wxInfo.idenStatus
                        ? basicInformation.swiftWxStatusMap[props.row.wxInfo.idenStatus].detail : "" }}
                  </span>
                </div>
                <div v-if="props.row.wxInfo.idenStatus === 'APPLYMENT_STATE_REJECTED'">
                  <div class="reda-text">驳回原因：</div>
                  <div v-for="(item, index) in props.row.wxInfo.audit_detail" :key="index">
                    <p style="font-size: 10px !important;display: inline-block;">⚫</p> {{
                      item.reject_reason }}
                  </div>
                </div>
                <div class="primarya-text">请用微信扫码查看详情</div>
                <el-image :src="props.row.wxInfo.infoQrcode" style="width: 100px; height: 100px"></el-image>
              </div>
              <div v-else class="reda-text"> 微信认证状态未获取到 </div>
              <div style="margin: 5px 0;" class="primarya-text">支付宝申请单状态</div>
              <div v-if="props.row.aliInfo">
                <div style="">
                  <div class="reda-text">{{ basicInformation.alipayStatusMap[props.row.aliInfo.idenStatus].status
                  }}：</div>
                </div>
                <!-- TODO:审核失败可能有详情 -->
                <!-- <div v-if="props.row.wxInfo.idenStatus === 'AUDIT_REJECT'">
                  <div class="reda-text">驳回原因：</div>
                  <div v-for="(item, index) in props.row.wxInfo.audit_detail" :key="index">
                    <p style="font-size: 10px !important;display: inline-block;">⚫</p> {{
                      item.reject_reason }}
                  </div>
                </div> -->
                <div class="primarya-text">请用支付宝扫码查看详情</div>
                <el-image :src="props.row.aliInfo.infoQrcode" style="width: 100px; height: 100px"></el-image>
              </div>
              <div v-else class="reda-text"> 支付宝认证状态未获取到 </div>
              <!-- <el-button size="small" style="width: 180px;" :disabled="!props.row.applyInfo"
                @click.native.prevent.stop="applyWxAli(props.row)" plain type="danger">
                微信支付宝认证
              </el-button> -->
            </div>
          </template>

        </el-table-column>
        <!-- 索引 -->
        <el-table-column type="index" align="center" label="索引">
        </el-table-column>
        <!-- id -->
        <el-table-column prop="merchant_id" width="100" align="center" label="店铺ID"><!-- formatter 数据过滤 -->
        </el-table-column>
        <el-table-column align="center" width="180" label="商户状态">
          <template slot-scope="scope">
            <p v-if="basicInformation.searchType === 'wx' && scope.row"
              :class="scope.row.applyInfo && scope.row.applyInfo.applyment_state === 'APPLYMENT_STATE_FINISHED' ? 'bluea-text' : 'reda-text'">
              {{
                scope.row.applyInfo && scope.row.applyInfo.applyment_state ?
                  basicInformation.wxpayStatusMap[scope.row.applyInfo.applyment_state].status : " 状态待获取" }} </p>
            <p v-if="basicInformation.searchType === 'swift'"
              :class="scope.row.applyInfo && scope.row.applyInfo.taskStatus && scope.row.applyInfo.taskStatus === '1' ? 'bluea-text' : 'reda-text'">
              {{ scope.row.applyInfo && scope.row.applyInfo.taskStatus ?
                basicInformation.swiftStatusMap[scope.row.applyInfo.taskStatus].status : "状态待获取"
              }}</p>
          </template>

        </el-table-column>
        <el-table-column v-for="(item, index) in basicInformation.tableColumnList" :key="index" :prop="item.prop"
          :formatter="item.prop === 'submitStatus' ? formatter : null" :width="item.width" :align="item.align"
          :label="item.label"><!-- formatter 数据过滤 -->
        </el-table-column>
        <el-table-column v-if="basicInformation.searchType === 'swift'" prop="mch_no" align="center" label="威富通店铺号">
        </el-table-column>
        <!-- <el-table-column v-if="basicInformation.searchType === 'swift'" align="center" label="操作">
          <template slot-scope="scope">
            <el-button size="small" :disabled="!scope.applyInfo" @click.native.prevent.stop="applyWxAli(scope.row)" plain type="danger">
              微信支付宝认证
            </el-button>
          </template>
        </el-table-column> -->
      </el-table>
    </div>
  </div>
</template>
<script>
import { getServiceCreateMerchant } from "@/api/service.js";
//eslint-disable-next-line
import { wxQuerMerchantApplymentId, wxQueryApplyment, wxQuerySheetApplyment, wxQueryServiceApplyment } from '@/api/wxService.js';
//eslint-disable-next-line
import { swiftApplyList, swiftQueryApply, swiftQueryWechatApply, swiftQueryAliApply, swiftSubmitWechatApply, swiftSubmitAliApply } from "@/api/swiftpass.js";
export default {
  data() {
    return {
      basicInformation: {
        expandRowKeys: [], //当前展开行
        loading: false,
        mchtbshow: true, //是否显示表格
        searchMchName: "", //搜索的店铺名
        searchType: "wx", //类型
        radioColumn: [{
          value: 'wx',
          label: "微信进件列表",
          disabled: false
        }, {
          value: 'swift',
          label: "威富通进件列表",
          disabled: false
        }, {
          value: 'ali',
          label: "支付宝进件列表",
          disabled: true
        }],
        tableColumnList: [{ //进件表格列属性
          prop: "mch_name",
          align: "center",
          label: "店铺名称",
          fixed: "left"
        }, {
          prop: "sub_name",
          align: "center",
          label: "店铺简称",
          fixed: false
        }, {
          prop: "applyment_id",
          align: "center",
          label: "进件系统id",
          fixed: false
        }], //表头列表
        alipayStatusMap: {
          AUDITING: { status: "审核中" },
          CONTACT_CONFIRM: { status: "待联系人确认" },
          LEGAL_CONFIRM: { status: "待法人确认" },
          AUDIT_PASS: { status: "审核通过" },
          AUDIT_REJECT: { status: "审核失败" },
          CONTACT_PROCESSING: { status: "联系人处理中" },
          AUDIT_FREEZE: { status: "已冻结" },
          CANCELED: { status: "已撤回" }
        },
        wxpayStatusMap: { //微信进件状态映射
          APPLYMENT_STATE_EDITTING: {
            status: "编辑中",
            detail: "提交申请发生错误导致，请尝试重新提交"
          },
          APPLYMENT_STATE_AUDITING: {
            status: "审核中",
            detail: "申请单正在审核中，超级管理员用微信打开'签约链接'，完成绑定微信号后，申请单进度将通过微信公众号通知超级管理员，引导完成后续步骤"
          },
          APPLYMENT_STATE_REJECTED: {
            status: "已驳回",
            detail: "请按照驳回原因修改申请资料，超级管理员用微信打开'签约链接'，完成绑定微信号，后续申请单进度将通过微信公众号通知超级管理员"
          },
          APPLYMENT_STATE_TO_BE_CONFIRMED: {
            status: "待账户验证",
            detail: "请超级管理员使用微信打开返回的'签约链接'，根据页面指引完成账户验证"
          },
          APPLYMENT_STATE_TO_BE_SIGNED: {
            status: "待签约",
            detail: "请超级管理员使用微信打开返回的'签约链接'，根据页面指引完成签约"
          },
          APPLYMENT_STATE_SIGNING: {
            status: "开通权限中",
            detail: "系统开通相关权限中，请耐心等待"
          },
          APPLYMENT_STATE_FINISHED: {
            status: "已完成",
            detail: "商户入驻申请已完成"
          },
          APPLYMENT_STATE_CANCELED: {
            status: "已作废",
            detail: "申请单已被撤销"
          }
        },
        swiftWxStatusMap: { //随行付微信进件状态映射
          APPLYMENT_STATE_WAITTING_FOR_AUDIT: {
            status: "审核中", detail: "请耐心等待3~7个工作日，微信支付将会完成审核。"
          },
          APPLYMENT_STATE_WAITTING_FOR_CONFIRM_CONTACT: {
            status: "待确认联系信息", detail: "请扫描微信支付返回的小程序码确认联系信息（此过程可修改超级管理员手机号）。"
          },
          APPLYMENT_STATE_WAITTING_FOR_CONFIRM_LEGALPERSON: {
            status: "待账户验证", detail: "请扫描微信支付返回的小程序码在小程序端完成账户验证。"
          },
          APPLYMENT_STATE_PASSED: {
            status: "审核通过", detail: "请扫描微信支付返回的小程序码在小程序端完成授权流程。"
          },
          APPLYMENT_STATE_REJECTED: {
            status: "审核驳回", detail: "请按照驳回原因修改申请资料，并更换业务申请编码，重新提交申请。"
          },
          APPLYMENT_STATE_FREEZED: {
            status: "已冻结", detail: "可能是该主体已完成过入驻，请查看驳回原因，并通知驳回原因中指定的联系人扫描微信支付返回的小程序码在小程序端完成授权流程。"
          },
          APPLYMENT_STATE_CANCELED: {
            status: "已作废", detail: "表示申请单已被撤销，无需再对其进行操作。"
          },
          APPLYMENT_STATE_OPENACCOUNT: {
            status: "已开户", detail: "表示该主体已经在微信完成过实名认证。"
          }
        },
        swiftStatusMap: { //随行付进件状态映射
          0: { status: "入驻审核中：", detail: "平台已经受理入驻申请但审核尚未完成。处于该状态时，可以通过渠道报备状态来进一步判断当前商户是否已经获取了交易权限。详情参见【商户入驻结果查询】的返回值对象repoInfo.repoStatus" },
          1: { status: "入驻通过：", detail: "商户入驻成功并且可以正常交易。" },
          2: { status: "入驻驳回：", detail: "入驻请求中上送的商户信息或图片资料未通过审核。需要按驳回原因修改资料后，通过【商户入驻修改】接口发起入驻修改。" },
          4: { status: "商户信息修改审核中：", detail: "平台已经受理存量商户信息修改申请但审核尚未完成。" },
          5: { status: "商户信息修改通过：", detail: "通过【商户信息修改】接口上送的存量商户信息修改申请通过审核。" },
          6: { status: "商户信息修改驳回：", detail: "通过【商户信息修改】接口上送的存量商户信息修改申请未通过审核，需要按照驳回原因修改后重新提交。" }
        }
      },
      allTableList: [], //所有店铺列表
      tableList: [] //显示的列表
    }
  },
  mounted() {
    this.radioChange("wx");//初始化为微信
  },
  methods: {
    /**
     * 选择状态修改
     * @param {string} e 'wx'-微信进件记录 'swift'-随行付进件记录
     */
    radioChange(e) {
      //修改表列信息
      /* if (e === 'wx') {
        this.basicInformation.tableColumnList = this.basicInformation.wxTableColumnList;
      }
      */
      /* if (e === 'swift') {
        this.basicInformation.tableColumnList.push({
          prop: "mch_no",
          align: "center",
          label: "威富通店铺号",
          fixed: "left"
        });
      } */
      this.basicInformation.expandRowKeys = [];
      this.getWxApplyment(e);//获取进件记录
    },
    /**
     * 模糊查询店铺
     */
    searchMerchant() {
      this.tableList = this.allTableList.filter(item => item.mch_name.indexOf(this.basicInformation.searchMchName) > -1 || item.sub_name.indexOf(this.basicInformation.searchMchName) > -1 || item.merchant_id.indexOf(this.basicInformation.searchMchName) > -1);
    },
    /**
     * 行展开触发事件
     * @param {object} row 行信息
     * @param {object} expandedRows 展开的信息
     */
    async expandChange(row, expandedRows) {
      //eslint-disable-next-line
      if (this.basicInformation.searchType === 'wx' && !row.applyInfo) {
        const is = await this.getQueryWxApplyment(row.applyment_id);
        this.$set(row, "applyInfo", is);
      }
      if (this.basicInformation.searchType === 'swift' && !row.applyInfo) {
        const is = await this.getSwiftQueryApply(row.applyment_id); //查询进件状态
        this.$set(row, "applyInfo", is.respData);
        await this.applyWxAli(row);
        //微信认证状态查询
        const wxApplyQuery = await swiftQueryWechatApply(row.applyInfo.mno);
        if (wxApplyQuery.code === "0000") {
          if (wxApplyQuery.respData.bizCode === "0000") {
            this.$set(row, "wxInfo", wxApplyQuery.respData);
            this.successMessage("微信：查询成功");
          } else {
            this.warnMessage("微信：" + wxApplyQuery.respData.bizMsg);
          }
        }
        const aliApplyQuery = await swiftQueryAliApply(row.applyInfo.mno);
        if (aliApplyQuery.code === "0000") {
          if (aliApplyQuery.respData.bizCode === "0000") {
            this.$set(row, "aliInfo", aliApplyQuery.respData);
            this.successMessage("支付宝：查询成功");
          } else {
            this.warnMessage("支付宝：" + aliApplyQuery.respData.bizMsg);
          }
        }
      }
      if (expandedRows.length === 0) { //需要取消
        this.basicInformation.expandRowKeys = expandedRows.filter(item =>
          item.keyId
        )
      }
      // this.basicInformation.expandRowKeys.push(row.keyId);
      //const res = await wxQueryApplyment(row.applyment_id);
    },
    /**
     * 微信支付宝认证
     */
    async applyWxAli(row) {
      const wxApply = await swiftSubmitWechatApply(row.applyInfo.mno);
      if (wxApply.code === "0000" && wxApply.respData && wxApply.respData.bizCode === "0000") {
        this.successMessage(wxApply.respData.bizMsg);
      } else if (wxApply.code === "0000" && wxApply.respData && wxApply.respData.bizCode !== "0000") {
        this.warnMessage(wxApply.respData.bizMsg);
      }
      const aliApply = await swiftSubmitWechatApply(row.applyInfo.mno);
      if (wxApply.code === "0000" && wxApply.respData && wxApply.respData.bizCode === "0000") {
        this.successMessage(aliApply.respData.bizMsg);
      } else if (wxApply.code === "0000" && wxApply.respData && wxApply.respData.bizCode !== "0000") {
        this.warnMessage(aliApply.respData.bizMsg);
      }
    },
    /**
    * 数据过滤
    * @param row 返回的行数据
    * @param column 返回的列信息
    */
    formatter(row, column) {
    },
    /**
     * 获取到所有所有微信进件信息
     * @param {'wx' | 'swift'} e wx-微信 swift-随行付
     */
    async getWxApplyment(e) {
      this.basicInformation.loading = true;
      let res = null;
      let list = [];
      //获取到所有所有微信进件信息
      if (e === 'wx') {
        res = await wxQueryServiceApplyment();
      } else if (e === 'swift') {
        res = await swiftApplyList();
      }
      if (!res || res.length === 0) {
        this.allTableList = [];
        this.tableList = [];
        this.basicInformation.loading = false;
        return;
      }
      //获取到所有店铺列表这一步是为了给列表添加店铺名称
      const mchRes = await getServiceCreateMerchant();
      if (this.testR(mchRes)) {
        const mch_list = mchRes.data.resp_data;
        res.forEach((apply, index) => {
          const mch_info = mch_list.find(mch => mch.merchant_id === apply.merchant_id);
          if (mch_info) {
            list.push({
              keyId: index,
              ...mch_info,
              ...apply
            });
          }
        });
      }
      this.basicInformation.expandRowKeys = [];
      this.allTableList = list.length > 0 ? list : res;
      this.tableList = this.allTableList;
      this.basicInformation.loading = false;
    },
    /**
     *通过applyment_id 获取到微信进件状态
     * @param {string} applyment_id 微信进件id
     */
    async getQueryWxApplyment(applyment_id) {
      return await wxQueryApplyment(applyment_id);
    },
    /**
     *通过applyment_id 获取到随行付进件状态
     * @param {string} applyment_id 随行付进件id
     */
    async getSwiftQueryApply(applyment_id) {
      return await swiftQueryApply(applyment_id);
    },
    /**
     * 搜索
     * @param {string} key 父组件输入框传进来的值
     */
    wtyTableIn(key) {
      this.tableList = this.allTableList.filter(item => item.mch_name.indexOf(key) > -1 || item.sub_name.indexOf(key) > -1 || item.merchant_id.indexOf(key) > -1);
    }
  }
}
</script>
<style lang="less" scoped>
.fa {
  width: 100%;
  height: 100%;
  background-color: #fff;
  min-height: 585px;
  padding: 0 10px;
  /* display: flex;
  align-items: center;
  overflow-x: hidden;
  flex-direction: column; */
}

.el-table-column-expand {
  width: 100%;
  height: 100%;
  padding: 0 5px;
  display: flex;
  flex-direction: column;
  font-size: 16px;
  /* .column-aduit{
    display: flex;

  } */
}

.table-expand label {
  color: #99a9bf !important;
}
</style>